import React, { FC } from "react";
import { Steps } from "./MyAppointment";
import { AppointmentPanelStep } from "./Steps/AppointmentPanelStep";
import { ExitStep } from "./Steps/ExitStep";
import { AppointmentInformationDto } from "@apiModels/AppointmentInformationDto.csharp";
import { ModalThemeColor } from "../../../Model/ModalThemeColor.csharp";
import classNames from "classnames";
import { StepThreeParams } from "../../Pages/MyAppointment/Steps/StepThreeParams.csharp";
import { StepFourParams } from "../../Pages/MyAppointment/Steps/StepFourParams.csharp";
import { CloseButton } from '../Booking/CloseButton/CloseButton';

interface AppointmentDetailsModalProps {
  onClose: () => void;
  currentStep: Steps;
  appointmentInformation: AppointmentInformationDto;
  errors: string[];
  cancellationLoading: boolean;
  goToHomePage: () => void;
  cancelAppointment: () => void;
  stepThreeParams: StepThreeParams;
  stepFourParams: StepFourParams;
  Modal: any;
  modalThemeColor: ModalThemeColor;
}

export const MyAppointmentModal: FC<AppointmentDetailsModalProps> = ({
  onClose,
  currentStep,
  appointmentInformation,
  errors,
  cancellationLoading,
  stepThreeParams,
  cancelAppointment,
  stepFourParams,
  goToHomePage,
  Modal,
  modalThemeColor,
}) => {
  const isVolvat = modalThemeColor == ModalThemeColor.Volvat;
  const isNimi = modalThemeColor == ModalThemeColor.Nimi;

  return (
    <Modal
      isOpen
      className={classNames("react-modal__content new-booking", {
        "theme-blue-medium": isVolvat,
        "theme-inherit-medium": isNimi,
      })}
      overlayClassName="react-modal__overlay"
      bodyOpenClassName="react-modal__open"
    >
      <div className="container-fluid">
        <div className="page-boundary page-boundary--booking-outer">
          <CloseButton onClick={onClose} />
          <div>
            <div className="page-boundary page-boundary--booking-inner">
              <div>
                {currentStep == Steps.panel && (
                  <AppointmentPanelStep
                    {...stepThreeParams}
                    cancelAppointment={cancelAppointment}
                    exit={onClose}
                    appointmentInformation={appointmentInformation!}
                    apiErrors={errors}
                    isLoading={cancellationLoading}
                    Modal={Modal}
                  />
                )}
                {currentStep == Steps.exit && (
                  <ExitStep {...stepFourParams} onClose={goToHomePage} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
